import Toolbar from './Toolbar';

export default Toolbar;